/* import __COLOCATED_TEMPLATE__ from './intercom-web-library.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */

import Component from '@glimmer/component';

interface Args {
  appIdCode: string;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class IntercomWebLibrary extends Component<Signature> {
  constructor(owner: never, args: Args) {
    super(owner, args);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'InstallationNew::Web::IntercomWebLibrary': typeof IntercomWebLibrary;
    'installation-new/web/intercom-web-library': typeof IntercomWebLibrary;
  }
}
